/* FLEXIUM — cuenta atrás compartida.
   Cada elemento [data-fx-clock] indica sus minutos con data-minutes.
   Se guarda el arranque en sessionStorage para que el contador no se
   reinicie al navegar entre páginas dentro de la misma visita. */
(function () {
  function init() {
    var relojes = document.querySelectorAll('[data-fx-clock]');
    if (!relojes.length) return;

    var minutos = parseInt(relojes[0].getAttribute('data-minutes'), 10);
    if (isNaN(minutos) || minutos <= 0) minutos = 15;
    var duracion = minutos * 60;

    var inicio;
    try {
      inicio = parseInt(sessionStorage.getItem('fxDeadline'), 10);
      if (!inicio || isNaN(inicio) || inicio < Date.now()) {
        inicio = Date.now() + duracion * 1000;
        sessionStorage.setItem('fxDeadline', inicio);
      }
    } catch (e) {
      inicio = Date.now() + duracion * 1000; // navegación privada
    }

    function pinta() {
      var restante = Math.max(0, Math.floor((inicio - Date.now()) / 1000));
      var m = Math.floor(restante / 60), s = restante % 60;
      var texto = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      for (var i = 0; i < relojes.length; i++) relojes[i].textContent = texto;
    }

    pinta();
    setInterval(pinta, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
